import { render, staticRenderFns } from "./ValuePair.vue?vue&type=template&id=5a248845&scoped=true&"
import script from "./ValuePair.vue?vue&type=script&lang=ts&"
export * from "./ValuePair.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a248845",
  null
  
)

export default component.exports